import { Routes, Route, Navigate } from "react-router-dom"

import HomeComponent from "../components/boards/home.component";
import ActasEnt from "../components/actas/actas.entrantes.component";
import ActasCur from "../components/actas/actas.curso.component";
import ActasComp from "../components/actas/actas.completas.component";
import ActasSusp from "../components/actas/actas.suspension.component";
import Todas from "../components/actas/actas.todas";
import ActasEdit from "../components/actas/actas.component";
import ActasSearch from "../components/actas/actas.search.component";
import Actas from "../components/actas/actas";
import ActasExpediente from "../components/actas/actas.expediente.component";
import UploadFiles from "../components/actas/actas.upload.files";
import Usuarios from "../components/boards/usuarios";

export const PrivateAppRouter = () => {
  return (
    <Routes>
      <Route path="/home" element={<HomeComponent />} />
      <Route path="/todas" element={<Todas />} />
      <Route path="/entrantes" element={<ActasEnt />} />
      <Route path="/curso" element={<ActasCur />} />
      <Route path="/completas" element={<ActasComp />} />
      <Route path="/suspension" element={<ActasSusp />} />
      <Route path="/edit/:id" element={<ActasEdit />} />
      <Route path="/acta/:id" element={<Actas />} />
      <Route path="/expediente" element={<ActasExpediente />} />
      <Route path="/upload/:id" element={<UploadFiles />} />
      <Route path="/" element={<ActasSearch />} />
      <Route path="/usuarios" element={<Usuarios />} />
      <Route path="/auth/files/download/:id"/>     
      <Route path="*" element={<Navigate to="/home"/>} />
    </Routes> 
  )
}